// eslint-disable-next-line no-unused-vars
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import moment from 'moment';
import { autoFormateDate } from '../utilities/utilities';

export const getDateInMMDDYYYYFormat = (enteredDate) => {
  if (enteredDate && enteredDate !== '' && enteredDate !== 'Invalid Date') {
    // const tempDate = new Date(enteredDate);
    // return (tempDate.getMonth() + 1) + '/' + tempDate.getDate() + '/' + tempDate.getFullYear();
    return moment(enteredDate).format('MM/DD/YYYY');
  }
  return null;
};

export const getDateInYYYYMMDDtoMMDDYYYY = (enteredDate) => {
  if (
    enteredDate &&
    enteredDate !== '' &&
    enteredDate !== 'Invalid Date' &&
    typeof enteredDate === 'string'
  ) {
    return `${enteredDate.substring(5, 7)}/${enteredDate.substring(
      8,
      10
    )}/${enteredDate.substring(0, 4)}`;
    // return moment(enteredDate).format('MM/DD/YYYY');
  }
  if (typeof enteredDate !== 'string') {
    let dateEntered = new Date(enteredDate);
    dateEntered = dateEntered.toISOString();
    return `${dateEntered.substring(5, 7)}/${dateEntered.substring(
      8,
      10
    )}/${dateEntered.substring(0, 4)}`;
  }
  return null;
};

export const getDateInMMDDYYYYFormatWithApendZero = (enteredDate) => {
  if (enteredDate && enteredDate !== '' && enteredDate !== 'Invalid Date') {
    // const tempDate = new Date(enteredDate);
    // let date = null;
    // let month = null;
    // if ((tempDate.getMonth() + 1) < 9) {
    //   month = '0' + (tempDate.getMonth() + 1).toString();
    // } else {
    //   month = (tempDate.getMonth() + 1).toString();
    // }
    // if (tempDate.getDate() < 9) {
    //   date = '0' + (tempDate.getDate()).toString();
    // } else {
    //   date = tempDate.getDate().toString();
    // }
    // return (month + '/' + date + '/' + tempDate.getFullYear().toString());
    return moment(enteredDate).format('MM/DD/YYYY');
  }
  return null;
};

export const getDateInYYYYMMDDFormatWithApendZero = (enteredDate) => {
  if (enteredDate && enteredDate !== '' && enteredDate !== 'Invalid Date') {
    const tempDate = new Date(enteredDate);
    let date = null;
    let month = null;
    if (tempDate.getMonth() + 1 <= 9) {
      month = `0${(tempDate.getMonth() + 1).toString()}`;
    } else {
      month = (tempDate.getMonth() + 1).toString();
    }
    if (tempDate.getDate() <= 9) {
      date = `0${tempDate.getDate().toString()}`;
    } else {
      date = tempDate.getDate().toString();
    }
    return `${tempDate.getFullYear().toString()}-${month}-${date}`;
    // return moment(enteredDate).format('MM/DD/YYYY');
  }
  return null;
};
export const dateSubString = (enteredDate) => {
  if (enteredDate) {
    return enteredDate.substring(0, 10);
  }
};
export const validateDateMinimumValueForSP = (date) => {
  let _date;
  if (typeof date === 'string') {
    _date = date.toString().substring(0, 4);
  } else if (date) {
    _date = getDateInYYYYMMDDFormatWithApendZero(date)
      .toString()
      .substring(0, 4);
  }
  if (_date && parseInt(_date) < 1964) {
    return true;
  }
  return false;

  // const _beginDate = new Date(date);
  // const _minBeginDate = new Date(1964, 0, 1, 0, 0, 0, 0); // 1964-1-1
  // if (_beginDate >= _minBeginDate) {
  //   return false;
  // } else {
  //   return true;
  // }
};

export const validateDateMinimumValue = (date) => {
  let _date;
  if (typeof date === 'string') {
    _date = date.toString().substring(6, 10);
  } else if (date) {
    _date = getDateInMMDDYYYYFormat(date).toString().substring(6, 10);
  }
  if (_date && parseInt(_date) < 1964) {
    return true;
  }
  return false;

  // const _beginDate = new Date(date);
  // const _minBeginDate = new Date(1964, 0, 1, 0, 0, 0, 0); // 1964-1-1
  // if (_beginDate >= _minBeginDate) {
  //   return false;
  // } else {
  //   return true;
  // }
};

/* This function is used to convert datetime to timestamp format */
export const setSelectedDate = (date) => {
  let selectedDate = new Date(null);

  if (
    date.getMonth() + 1 < 10 &&
    date.getMonth() + 1 > 0 &&
    date.getDate() < 10 &&
    date.getDate() > 0
  ) {
    selectedDate = `0${
      date.getMonth() + 1
    }/0${date.getDate()}/${date.getFullYear()}`;
  } else if (date.getMonth() + 1 < 10 && date.getMonth() + 1 > 0) {
    selectedDate = `0${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()}`;
  } else if (date.getDate() < 10 && date.getDate() > 0) {
    selectedDate = `${
      date.getMonth() + 1
    }/0${date.getDate()}/${date.getFullYear()}`;
  } else {
    selectedDate = `${
      date.getMonth() + 1
    }/${date.getDate()}/${date.getFullYear()}`;
  }

  return selectedDate;
};

export const generateUUID = () => {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

export const getDifferenceInDays = (startDate, endDate) => {
  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds Y-M-D
  const firstDate = new Date(startDate);
  const secondDate = new Date(endDate);

  return Math.abs((secondDate - firstDate) / oneDay);
};

// this function takes an array of date ranges in this format:
// [{ start: Date, end: Date}]
// the array is first sorted, and then checked for any overlap

export const overlapCheckWithDateRange = (dateRanges) => {
  const sortedRanges = dateRanges.sort((previous, current) => {
    // get the start date from previous and current
    const previousTime = previous.start.getTime();
    const currentTime = current.start.getTime();

    // if the previous is earlier than the current
    if (previousTime < currentTime) {
      return -1;
    }

    // if the previous time is the same as the current time
    if (previousTime === currentTime) {
      return 0;
    }

    // if the previous time is later than the current time
    return 1;
  });

  const result = sortedRanges.reduce(
    (result, current, idx, arr) => {
      // get the previous range
      if (idx === 0) {
        return result;
      }
      const previous = arr[idx - 1];

      // check for any overlap
      const previousEnd = previous.end.getTime();
      const currentStart = current.start.getTime();
      const overlap = previousEnd >= currentStart;

      // store the result
      if (overlap) {
        // yes, there is overlap
        result.overlap = true;
        // store the specific ranges that overlap
        result.ranges.push({
          previous: previous,
          current: current,
        });
      }

      return result;

      // seed the reduce
    },
    { overlap: false, ranges: [] }
  );
  // return the final results
  return result;
};
export const convertDateTimeToTimestamp = (dateTimeValue) => {
  const dateTimestamp = Date.parse(dateTimeValue);
  return dateTimestamp / 1000;
};

/* This function is used to compare two dates
 * Returns false if date1 is greater than date2
 * Return true if date1 is less than or equals to date2
 */
export const compareTwoDates = (date1, date2) => {
  date1 = new Date(date1);
  date2 = new Date(autoFormateDate(date2));
  const dateone = new Date(
    date1.getFullYear(),
    date1.getMonth(),
    date1.getDate(),
    0,
    0,
    0
  );
  const datetwo = new Date(
    date2.getFullYear(),
    date2.getMonth(),
    date2.getDate(),
    0,
    0,
    0
  );
  if (dateone > datetwo) {
    return false;
  }
  return true;
};

export const compareTwoDatesGreaterThanOrEqual = (date1, date2) => {
  date1 = new Date(date1);
  date2 = new Date(date2);
  const dateone = new Date(
    date1.getFullYear(),
    date1.getMonth(),
    date1.getDate(),
    0,
    0,
    0
  );
  const datetwo = new Date(
    date2.getFullYear(),
    date2.getMonth(),
    date2.getDate(),
    0,
    0,
    0
  );
  if (dateone >= datetwo) {
    return false;
  }
  return true;
};

/* This function is used to validate date string
 * Returns false if month, day or year is not a valid one
 */
export const checkForValidDateString = (dateString) => {
  // First checking for the pattern
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
    return false;
  }

  // Parsing the date parts to integers
  const parts = dateString.split('/');
  const day = parseInt(parts[1], 10);
  const month = parseInt(parts[0], 10);
  const year = parseInt(parts[2], 10);

  // Checking the ranges of month and year
  if (year > 9999 || month === 0 || month > 12) {
    return false;
  }

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
    monthLength[1] = 29;
  }

  // Checking the range of the day
  return day > 0 && day <= monthLength[month - 1];
};

export const checkForValidDateStringYYYYMMDD = (dateString) => {
  // First checking for the pattern
  if (!/^\d{1,4}-\d{1,2}-\d{2}$/.test(dateString)) {
    return false;
  }

  // Parsing the date parts to integers
  const parts = dateString.split('-');
  const day = parseInt(parts[2], 10);
  const month = parseInt(parts[1], 10);
  const year = parseInt(parts[0], 10);

  // Checking the ranges of month and year
  if (year > 9999 || month === 0 || month > 12) {
    return false;
  }

  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
    monthLength[1] = 29;
  }

  // Checking the range of the day
  return day > 0 && day <= monthLength[month - 1];
};
/* This function returns UTC timestamp for auditTimeStamp and addedAuditTimeStamp
 */
export const getUTCTimeStamp = () => {
  return moment().utc().format('YYYY-MM-DDTHH:mm:ss.SSSZZ');
};

export const getUTCTimeStampYYYYMMDD = (date) => {
  return moment(moment.utc(date).startOf('day')).format('YYYY-MM-DD');
};
export const getUTCTimeStampMMDDYYYY = (date) => {
  return moment.parseZone(date).utc(true).format('MM/DD/YYYY');
};

// current year
export const currentYear = () => {
  return moment().format('YYYY');
};

export const getDateUTCTimeStamp = (date) => {
  return moment(date).utc().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
};
export const getDateTimeStamp = (date) => {
  return moment(date).format('YYYY-MM-DDTHH:mm:ss.SSS');
};
export const setDateFormatter = (date) => {
  return date ? moment(date)?.format('MM/DD/YYYY') : null;
};
export const getDateTimeStampWithTimeZone = (date) => {
  return moment(date).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
};

export const getDateETCTimeStamp = (date) => {
  const splitDate = date !== '' ? date.split('/') : [];
  const formattedDate =
    splitDate.length > 0
      ? splitDate[2].concat('-', splitDate[0], '-', splitDate[1])
      : '';
  return formattedDate.concat('T00:00:00.000');
};

export const checkFutureDate = (date) => {
  const dateTime = moment().format('MM/DD/YYYY');
  const secondForm = moment().format('MM/DD/YY');

  if (
    moment(date).isSameOrBefore(dateTime) ||
    moment(date).isSameOrBefore(secondForm)
  ) {
    return true;
  }
  return false;
};

export const checkBackwardDate = (date) => {
  if (
    moment(date).isBefore('01/01/1992') ||
    moment(date).isBefore('01/01/92')
  ) {
    return false;
  }
  return true;
};

export const convertMillisecondsToDate = (milli) => {
  return moment(milli).format('MM/DD/YYYY');
};

export const compareTwoEqualDates = (date1, date2) => {
  try {
    if (date1 && date2) {
      const dateOne = new Date(moment(date1).format('MM/DD/YYYY')).getTime();
      const dateTwo = new Date(moment(date2).format('MM/DD/YYYY')).getTime();
      return dateOne === dateTwo;
    }
    return false;
  } catch (error) {
    return false;
  }
};

// This function check the date in MM/DD format
export const validMMDDFormat = (dateString) => {
  // Parsing the date parts to integers
  const parts = dateString.split('/');
  const month = parseInt(parts[0], 10);
  const day = parseInt(parts[1], 10);

  if (
    month !== 'NaN' &&
    month >= 1 &&
    month <= 12 &&
    day !== 'NaN' &&
    day >= 1 &&
    day <= 31
  ) {
    return true;
  }
  return false;
};

export const getDateMMDDYYYTimeStamp = (date) => {
  return moment(date).format('MM/DD/YYYY HH:mm');
};

export const quarterComparator = (qtr1, qtr2) => {
  const qtr1Number = qtrToNumber(qtr1);
  const qtr2Number = qtrToNumber(qtr2);

  if (qtr1Number === null && qtr2Number === null) {
    return 0;
  }
  if (qtr1Number === null) {
    return -1;
  }
  if (qtr2Number === null) {
    return 1;
  }
  return qtr1Number - qtr2Number;
};

function qtrToNumber(qtr) {
  if (qtr === undefined || qtr === null || qtr.length !== 6) {
    return null;
  }

  const yearNumber = Number.parseInt(qtr.substring(2, 6));
  const qtrNumber = Number.parseInt(qtr.substring(0, 1));

  return yearNumber * 10000 + qtrNumber * 10;
}

export const convertQuarter = (inputValue) => {
  const regex = /^(\d+)Q(\d{4})$/; // regex to match the expected input format

  if (regex.test(inputValue)) {
    const [, quarter, year] = inputValue.match(regex); // extracting quarter and year using regex capture groups

    const converted = `${year}${quarter}`;
    return converted;
  }
  return 'Invalid input';
};

export const compareToFutureDate = (presentDate, enteredDate) => {
  const present = new Date(presentDate);
  const entered = new Date(enteredDate);

  return entered > present;
};

export const checkValidDate = (enteredDate) => {
  const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/(19|20)\d{2}$/;
  return dateRegex.test(enteredDate);
};

export const formatToCorrectDate = (dt) => {
  if (!dt) {
    return dt;
  }
  const [month, day, year] = dt.split('/').map((p) => p.trim());
  if (
    year &&
    year.length === 4 &&
    !isNaN(year) &&
    year >= '0000' &&
    year <= '0099'
  ) {
    const correctDate = moment(`${month}/${day}/${year}`, 'MM/DD/YYYY', true);
    if (correctDate.isValid()) {
      return correctDate.toDate();
    }
  }
  return dt;
};
export const formatDateToSortableDateStr = (dt) => {
  const year = dt.getFullYear().toString().padStart(4, '0');
  const month = dt.getMonth().toString().padStart(2, '0');
  const day = dt.getDate().toString().padStart(2, '0');
  return `${month}/${day}/${year}`;
};
export const monthToComparableNumber = (date) => {
  if (date === undefined || date === null) {
    return null;
  }
  let dt = date;
  if (date instanceof Date && !isNaN(date.getTime())) {
    dt = formatDateToSortableDateStr(date);
  }
  if (dt.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(dt.substring(6, 10));
  const dayNumber = Number.parseInt(dt.substring(3, 5));
  const monthNumber = Number.parseInt(dt.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
};

export const dateComparator = (date1, date2) => {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
};
export const mmToMonthName = (mm) => {
  if (mm === null || mm === undefined) return '';
  const m = String(mm).padStart(2, '0').slice(0, 2);
  const n = Number(m);
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return n >= 1 && n <= 12 ? monthNames[n - 1] : '';
};

export const monthNameFromMMDDYYYY = (dateStr) => {
  if (!dateStr || typeof dateStr !== 'string') return ''; 
  const m = dateStr.match(/^(\d{1,2})\/\d{1,2}\/\d{4}$/);
  if (!m) return '';
  return mmToMonthName(m[1]);
};